var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('entity-child-card');
import { EntityThumbnailImage } from './entity-image';
import { EntityLink } from './entity-link';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from '../elements/icon';
import { Content } from '../elements/content';
import { ChevronRightIconGlyph } from '@shapeable/icons';
export var EntityChildCardDefaultProps = {
  variant: "normal"
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: block;\n\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    position: relative;\n    display: block;\n\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    box-sizing: border-box;\n    padding: ", " ", ";\n    background: rgba(0,0,0,0.6);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    box-sizing: border-box;\n    padding: ", " ", ";\n    background: rgba(0,0,0,0.6);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  "])), theme.UNIT(4), theme.UNIT(3))
});
var TitlesStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-family: ", ";\n    color: ", ";\n    padding-right: ", ";\n    font-weight: 400; \n\n    ", "\n  "], ["\n    font-family: ", ";\n    color: ", ";\n    padding-right: ", ";\n    font-weight: 400; \n\n    ", "\n  "])), theme.FONT('serif'), theme.COLOR('light'), theme.UNIT(10), function (_a) {
    var variant = _a.variant;
    return variant === 'feature' && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      font-size: 1.6em;\n      font-weight: 500; \n      line-height: 1.1em;\n    "], ["\n      font-size: 1.6em;\n      font-weight: 500; \n      line-height: 1.1em;\n    "])));
  })
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-family: ", ";\n    color: ", ";\n    padding-right: ", ";\n    font-weight: 300;\n    font-size: 1em;\n    margin-top: 6px;\n    line-height: 1.1em;\n\n    b, strong {\n      font-weight: 600;\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    color: ", ";\n    padding-right: ", ";\n    font-weight: 300;\n    font-size: 1em;\n    margin-top: 6px;\n    line-height: 1.1em;\n\n    b, strong {\n      font-weight: 600;\n      color: ", ";\n    }\n  "])), theme.FONT('serif'), theme.COLOR('light'), theme.UNIT(4), theme.COLOR('light'))
});
var IconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: ", ";\n    ", ";\n  "], ["\n    margin-top: ", ";\n    ", ";\n  "])), theme.UNIT(0), theme.FILL('light'))
});
var ImageStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: styled(EntityLink)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Titles: styled.div.attrs(cls.attr('titles'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Name: styled.span.attrs(cls.attr('name'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Subtitle: styled(Content)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Icon: styled(Icon)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Image: styled(EntityThumbnailImage)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Description: styled(Content)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var EntityChildCard = function (props) {
  var className = props.className,
    entity = props.entity,
    description = props.description,
    variant = props.variant;
  var name = entity.name,
    subtitle = entity.subtitle;
  var hasDescription = !!description;
  var hasSubtitle = variant === "feature" && !!entity.subtitle;
  var aspectRatio = props.aspectRatio || variant === "normal" ? {
    base: 14 / 9,
    tablet: 14 / 9
  } : {
    base: 14 / 9,
    desktopMid: 1210 / 1014
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Link, {
    entity: entity
  }, React.createElement(My.Image, {
    entity: entity,
    aspectRatio: aspectRatio
  }), React.createElement(My.Body, null, React.createElement(My.Titles, null, React.createElement(My.Name, {
    variant: variant
  }, name), hasSubtitle && React.createElement(My.Subtitle, {
    html: subtitle
  })), React.createElement(My.Icon, {
    size: 16
  }, React.createElement(ChevronRightIconGlyph, null)))), hasDescription && React.createElement(My.Description, {
    html: description
  }));
};
EntityChildCard.defaultProps = EntityChildCardDefaultProps;
EntityChildCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;